/*
* @Description: 第三方应用维护
* @Author: fxg
* @Date: 2020-06-29 11:18:28
* @LastEditors: fxg
* @LastEditTime: 2020-06-29 13:34:36
*/
import request from '@/utils/request'
export function updateStatus(data) {
  return request({
    url: '/third/system/base/thirdapp/update_status',
    method: 'post',
    data
  })
}
export function queryPage(data) {
  return request({
    url: '/third/system/base/thirdapp/query_page',
    method: 'post',
    data
  })
}
export function saveOrUpdate(data) {
  return request({
    url: '/third/system/base/thirdapp/save_or_update',
    method: 'post',
    data
  })
}
// 获取appkey和appsecret 
export function createKeySecret() {
  return request({
    url: '/third/open/api/app_info',
    method: 'get',
  })
}
// 保存关联关系
export function saveApiCodes(data) {
  return request({
    url: '/third/system/base/join/save',
    method: 'post',
    data
  })
}
// 对外接口api
export function getForeignApi(data) {
  return request({
    url: '/third/system/base/foreignapi/query_page',
    method: 'post',
    data
  })
}
// 获取对外api(修改)
export function getForeignApiTwo(key) {
  return request({
    url: '/third/system/base/join/api_id_list?appKey='+key,
    method: 'get',
  })
}